(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
      constructor() {
        super();
      }
  
      connectedCallback() {
        this.header = document.querySelector('.section-header');
        this.sticky = this.header.querySelector('sticky-header');
        this.firstLogo = document.querySelector('.header-first-logo');
        this.secondLogo = document.querySelector('.header-second-logo');
        this.menus = document.querySelectorAll('.mega-menu');
        this.megaMenu = document.querySelectorAll('.mega-menu summary');
        this.drawerBtn = this.header.querySelector('#Details-menu-drawer-container summary');
        this.template_is_special = this.sticky.classList.contains('as-absolute') ? true : false;
        this.template_is_light = this.sticky.classList.contains('template_is_light') ? true : false;
        this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
        this.headerBounds = {};

        this.isHomepage = this.secondLogo.classList.contains('!as-hidden') ? true : false;

        this.header_open = false;

        this.setHeaderHeight();
  
        window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
  
        if (this.headerIsAlwaysSticky) {
          this.header.classList.add('shopify-section-header-sticky');
        };
  
        this.currentScrollTop = 0;
        this.preventReveal = false;
        this.predictiveSearch = this.querySelector('predictive-search');
  
        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => this.preventReveal = true;
  
        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);


        this.onBtnClickDrawer = this.onBtnClick.bind(this);
        this.drawerBtn.addEventListener('click', this.onBtnClickDrawer, false);

        this.createObserver();
      }
  
      setHeaderHeight() {
        if (this.template_is_special )
        document.documentElement.style.setProperty('--header-height', `${this.sticky.offsetHeight}px`);
        else
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      }
  
      disconnectedCallback() {
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.removeEventListener('scroll', this.onScrollHandler);
      }
  
      createObserver() {
        let observer = new IntersectionObserver((entries, observer) => {
          this.headerBounds = entries[0].intersectionRect;
          observer.disconnect();
        });
  
        observer.observe(this.header);
      }

      onBtnClick() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          if (scrollTop <= this.headerBounds.top) {

            if(this.template_is_special){
              if(this.sticky.classList.contains('as-absolute')){
                if (this.template_is_light){
                  this.sticky.classList.remove('color-scheme-3');
                }
                console.log('light:', this.template_is_light);
                this.sticky.classList.remove('as-absolute');
                this.sticky.classList.remove('as-w-full');
                this.sticky.classList.remove('as-bg-[#FEF9F3]');
                this.sticky.classList.remove('!as-bg-transparent');
                if (this.isHomepage){
                  this.firstLogo.classList.add('!as-hidden');
                  this.secondLogo.classList.remove('!as-hidden');
                  }
              } else {
                  if (this.template_is_light){
                    this.sticky.classList.add('color-scheme-3');
                  }
                  this.sticky.classList.add('as-absolute');
                  this.sticky.classList.add('as-w-full');
                  this.sticky.classList.add('as-bg-[#FEF9F3]');
                  this.sticky.classList.add('!as-bg-transparent');
                  if (this.isHomepage){
                    this.firstLogo.classList.remove('!as-hidden');
                    this.secondLogo.classList.add('!as-hidden');
                  }
              }
            } 
          }
        }
      
    
  
      onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  
        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

        this.menus.forEach((element) => {
              if (element.open){
                this.header_open = true;
                console.log('is open');
              }
              else {
                console.log('is close');
              }
            });
  
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          console.log('scroll down');
            
            if( this.template_is_special){
              this.header_open = false;
              this.menus.forEach((element) => {
                  if (element.open){
                    this.header_open = true;
                  }
                });
                if (this.header_open == true){
                  console.log('header_open is true');
                } else {
                  if (this.template_is_light){
                    this.sticky.classList.remove('color-scheme-3');
                  }
                  //this.sticky.classList.remove('as-absolute');
                  //this.sticky.classList.remove('as-w-full');
                  this.sticky.classList.remove('scroll-in-header');
                  this.sticky.classList.remove('as-bg-[#FEF9F3]');
                  this.sticky.classList.remove('!as-bg-transparent');
                  this.firstLogo.classList.add('!as-hidden');
                  this.secondLogo.classList.remove('!as-hidden');
                } 
            }
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          console.log('scroll top');
          if( this.template_is_special){
            if (this.template_is_light){
                    this.sticky.classList.remove('color-scheme-3');
                  }
          }

          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);
  
            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);
  
            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          this.header.classList.remove('scrolled-past-header');
          requestAnimationFrame(this.reset.bind(this));
          console.log('scroll in header');
          if( this.template_is_special){
            this.header_open = false;
            this.menus.forEach((element) => {
              if (element.open){
                this.header_open = true;
              } 
            });
            if (this.header_open == true){
                  console.log('header_open is true');
                } else {
                if (this.template_is_light){
                  this.sticky.classList.add('color-scheme-3');
                }
                //this.sticky.classList.add('as-absolute');
                //this.sticky.classList.add('as-w-full');
                this.sticky.classList.add('as-bg-[#FEF9F3]');
                this.sticky.classList.add('!as-bg-transparent');
                this.sticky.classList.add('scroll-in-header');
                if (this.isHomepage){
                  this.firstLogo.classList.remove('!as-hidden');
                  this.secondLogo.classList.add('!as-hidden');
                  }
            }
          } 
        }
  
        this.currentScrollTop = scrollTop;
      }
  
      hide() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
        this.closeMenuDisclosure();
        this.closeSearchModal();
      }
  
      reveal() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.remove('shopify-section-header-hidden');
      }
  
      reset() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      }
  
      closeMenuDisclosure() {
        this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
        this.disclosures.forEach(disclosure => disclosure.close());
      }
  
      closeSearchModal() {
        this.searchModal = this.searchModal || this.header.querySelector('details-modal');
        this.searchModal.close(false);
      }
    }
  
    customElements.define('sticky-header', StickyHeader);
  
  } catch(e) { console.error(e); }
})();
})();
